// extracted by mini-css-extract-plugin
export default {"servicesProvided":"nqNLp019N3uWlH081URZ","title":"yiaHf08oqoXDtvYPdump","service":"Ss5IxJ5ZhOkAv_vxdkif"};